import { Tool } from '../../types';

export const documentManagementTools: Tool[] = [
  {
    id: 'google-workspace',
    name: 'Google Workspace',
    category: 'Document Management',
    description: 'Suite of cloud-based productivity and collaboration tools',
    pricing: ['low', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations', 'security'],
    bestFor: ['startup', 'small-business', 'freelancer'],
    compatibleWith: ['agency', 'service-business', 'consulting-firm'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'education', 'marketing'],
    website: 'https://workspace.google.com',
    imageUrl: 'https://logo.clearbit.com/google.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'dropbox',
    name: 'Dropbox',
    category: 'Document Management',
    description: 'Cloud storage and file synchronization platform',
    pricing: ['free', 'medium'],
    features: ['ease-of-use', 'mobile', 'security'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['content-creator', 'service-business'],
    goals: ['streamline-operations'],
    industries: ['creative', 'technology', 'marketing'],
    website: 'https://www.dropbox.com',
    imageUrl: 'https://logo.clearbit.com/dropbox.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner'],
    minTeamSize: 'solo'
  },
  {
    id: 'microsoft-365',
    name: 'Microsoft 365',
    category: 'Document Management',
    description: 'Comprehensive suite of productivity and collaboration tools',
    pricing: ['medium', 'high'],
    features: ['integrations', 'mobile', 'security', 'scalability'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'finance', 'consulting'],
    website: 'https://www.microsoft.com/microsoft-365',
    imageUrl: 'https://logo.clearbit.com/microsoft.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];